module.exports = __webpack_public_path__ + "media/asset/images/excel-eb57fe11fc0aa63d44c1c01533e7014d.png";